import { render, staticRenderFns } from "./StudentsUploadAdmin.vue?vue&type=template&id=5bcbdc74&scoped=true&"
import script from "./StudentsUploadAdmin.vue?vue&type=script&lang=js&"
export * from "./StudentsUploadAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StudentsUploadAdmin.vue?vue&type=style&index=0&id=5bcbdc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcbdc74",
  null
  
)

export default component.exports